import React from "react"
import types from "prop-types"
import { FormsyMultilineTextInput } from "shared/inputs"

const GroupDescription = ({ group }) => (
  <div>
    <label htmlFor={`group-${group.id}-description`}>Description (Optional)</label>
    <FormsyMultilineTextInput
      className="bordered-base-input text-sm"
      uuid={`group-${group.id}-description`}
      name="description"
      placeholder="Briefly describe the group"
      value={group.description || ""}
      rows="4"
      validations={{
        noExcelMetacharacters: true,
        noHTML: true,
      }}
    />
  </div>
)

GroupDescription.propTypes = {
  group: types.object.isRequired,
}

export default GroupDescription
